import React from "react";
import { BsFillPatchCheckFill } from "react-icons/bs";

const About = () => {
  return (
    <div className="about">
      <div className="row">
        <div className="col-lg-6 col-md-12 col-12">
          <img src="images/body/b1.png" alt="" />
        </div>
        <div className="col-lg-6 col-md-12 col-12 content">
          <h3>Committed to delivering reliable and accurate results</h3>
          <p className="mb-3">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique
            corrupti aperiam enim explicabo ad aut labore dolore minima facere.
            Molestias amet neque reiciendis ad? In culpa sed repellat quidem
            similique.
          </p>
          <div className="check">
            <p>
              <BsFillPatchCheckFill />
              <span> Lorem ipsum dolor sit amet</span>
            </p>
            <p>
              <BsFillPatchCheckFill />
              <span> Lorem ipsum dolor sit amet</span>
            </p>
            <p>
              <BsFillPatchCheckFill />
              <span> Lorem ipsum dolor sit amet</span>
            </p>
            <p>
              <BsFillPatchCheckFill />
              <span> Lorem ipsum dolor sit amet</span>
            </p>
            <p>
              <BsFillPatchCheckFill />
              <span> Lorem ipsum dolor sit amet</span>
            </p>
          </div>
          <div className="mt-5">
            <a href="/" className="btn--base">
              Access The Code Pilot
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
